<div class="single-form" fxLayout="column" fxLayoutAlign="space-between center" fxFlexFill>
  
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="padding-25 mat-elevation-z5" fxFlex="370px" fxFlex.sm="80%" fxFlex.lt-sm="90%">
      <form [formGroup]="resetPasswordForm" fxLayout="column" (ngSubmit)="resetPasswordForm.valid && onSubmit(resetPasswordForm.value)" autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>

        <!--Image Logo-->
        <img id="id_reset_pass_img_logo" class="logo" src="assets/images/swiftrewards-icon.png" alt="E-Science Logo">

        <!--Statement Logo-->
        <!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

        <mat-label class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
          {{errorMessage}}
        </mat-label>

        <mat-form-field>
          <input matInput 
            id="id_reset_pass_txtbox_user"
            [placeholder]="'LABEL_EMAIL' | translate" 
            formControlName="username">
          <mat-error *ngIf="resetPasswordForm.controls['username'].hasError('required')">
            {{ 'MSG_ERROR_EMAIL_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['username'].hasError('notExisting')">
            {{ 'MSG_ERROR_USERNAME_NOT_EXISTING' | translate }}
          </mat-error>
        </mat-form-field>
        
        <mat-form-field fxFlex>
          <input matInput 
            id="id_reset_pass_txtbox_veri_code"
            maxlength="6" 
            [placeholder]="'LABEL_VERIFICATION_CODE' | translate" 
            formControlName="code">
          <button fxFlex matSuffix mat-button 
            id="id_reset_pass_btn_resend"
            [disabled]="resetPasswordForm.controls['username'].invalid"
            (click)="resendVerificationCode(resetPasswordForm.value)"
            type="button"
            color="primary" 
            >
            {{ (isResendingCode ? 'LABEL_RESENDING_VERIFICATION_CODE' : 'LABEL_RESEND_VERIFICATION_CODE') | translate }}
          </button>
          <mat-error *ngIf="resetPasswordForm.controls['code'].hasError('required')">
            {{ 'MSG_ERROR_VERIFICATION_CODE_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['code'].hasError('codeMismatch')">
            {{ 'MSG_ERROR_VERIFICATION_CODE_INCORRECT' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput 
            id="id_reset_pass_txtbox_pass"
            [placeholder]="'LABEL_PASSWORD'| translate" 
            minlength="8" 
            maxlength="60" 
            [type]="show.password ? 'text' : 'password'"
            formControlName="password">
          <mat-icon *ngIf="resetPasswordForm.controls['password'].value" 
            matSuffix 
            (click)="show.password = !show.password"
            [svgIcon]="show.password ? 'eye-off' : 'eye'">
          </mat-icon>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('required')">
            {{ 'MSG_ERROR_PASSWORD_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('minlength')">
            {{ 'MSG_ERROR_PASSWORD_MIN_LENGTH' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('maxlength')">
            {{ 'MSG_ERROR_PASSWORD_MAX_LENGTH' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('pattern')">
            {{ 'MSG_ERROR_PASSWORD_PATTERN' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('invalidPassword')">
            {{ 'MSG_ERROR_INVALID_PASSWORD' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('matchPassword')">
            {{ 'MSG_ERROR_SAME_LAST_PASSWORD' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['password'].hasError('reusedPassword')">
            Password has already been used. Pick a different one.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput 
            id="id_reset_pass_txtbox_confirm_pass"
            [placeholder]="'LABEL_CONFIRM_PASSWORD' | translate" 
            [type]="show.confirm ? 'text' : 'password'"
            formControlName="confirmPassword">
          <mat-icon 
            *ngIf="resetPasswordForm.controls['confirmPassword'].value" 
            matSuffix 
            (click)="show.confirm = !show.confirm"
            [svgIcon]="show.confirm ? 'eye-off' : 'eye'">
          </mat-icon>
          <mat-error *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('required')">
            {{ 'MSG_ERROR_PASSWORD_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('matchPassword')">
            {{ 'MSG_ERROR_INCORRECT_CONFIRM_PASSWORD' | translate}}
          </mat-error>
        </mat-form-field>

        <button id="id_reset_pass_btn_reset_pass" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
          {{ (isSubmitting ? 'LABEL_RESETTING_PASSWORD' : 'LABEL_RESET_PASSWORD') | translate }}
        </button>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
          <button fxFlex mat-button 
            id="id_reset_pass_btn_return"
            type="button"
            routerLink="../login" 
            [queryParams]="resetPasswordForm.controls['username'].valid ? { username: resetPasswordForm.controls['username'].value } : {}"
            color="primary">
            {{ 'LABEL_RETURN_TO_LOGIN' | translate }}
          </button>
        </div>

      </form>
    </mat-card>
  </div>
  
  <div fxFlexAlign="end" class="width-100">
    <esc-footer></esc-footer>
  </div>
</div>